import React, { useState } from 'react';

import useDebouncedCallback from '@lib/hooks/useDebouncedCallback';

import FilterDiagnosesHeader from './FilterDiagnosesHeader';
import FilterDiagnosesList from './FilterDiagnosesList';

interface FilterDiagnosesProps {
  type?: 'icd9' | 'icd10';
}

const FilterDiagnoses: React.FC<FilterDiagnosesProps> = ({ type: typeProps = 'icd9' }) => {
  const [search, setSearch] = useState('');
  const [debouncedSetSearch] = useDebouncedCallback(setSearch, 500);
  const type = `${typeProps}Code`;

  return (
    <React.Fragment>
      <FilterDiagnosesHeader type={type} onSearchChange={debouncedSetSearch} />
      <FilterDiagnosesList type={type} searchTerm={search} />
    </React.Fragment>
  );
};

export default FilterDiagnoses;
